import { FC } from "react";
import "./style.scss";

interface BadgePropTypes {
  label: string;
  labelColor?: string;
  backgroundColor?: string;
  border?: string;
  dot?: boolean;
  dotColor?: string;
}

const Badge: FC<BadgePropTypes> = ({
  label,
  labelColor,
  backgroundColor,
  border,
  dot,
  dotColor,
}) => {
  return (
    <div
      className="badge-component-wrapper"
      style={{
        background: backgroundColor ? backgroundColor : "gray",
        border: border ? border : "unset",
      }}
    >
      {dot && (
        <div
          className="badge-dot"
          style={{ background: dotColor ? dotColor : "yellow" }}
        />
      )}
      <span
        className="badge-text"
        style={{ color: labelColor ? labelColor : "black" }}
      >
        {label}
      </span>
    </div>
  );
};

export default Badge;
